import { render, staticRenderFns } from "./MainBudgetSettings.vue?vue&type=template&id=8e979b58&scoped=true&"
import script from "./MainBudgetSettings.vue?vue&type=script&lang=ts&"
export * from "./MainBudgetSettings.vue?vue&type=script&lang=ts&"
import style0 from "./MainBudgetSettings.vue?vue&type=style&index=0&id=8e979b58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e979b58",
  null
  
)

export default component.exports